import React from 'react'

import { FiCamera } from 'react-icons/fi'
import { TbPhotoVideo } from 'react-icons/tb'
import { styled } from 'styled-components'

import { useChallenge, useUser } from '../../../context'
import { ChallengeStatus } from '../../../types'
import { translateStatus } from '../../../utilFunctions/transformFunc'
import PlainCard from '../PlainCard'

export const PreviewCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PreviewImage = styled.img`
  width: 100%;
  border-radius: 18px;
  height: 190px;
  object-fit: cover;
`

export const PreviewBadge = styled.div<{ $status: ChallengeStatus }>`
  position: absolute;
  top: 12px;
  left: 12px;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: white;
  background: ${({ $status }) =>
    $status === 'active'
      ? '#22c55e'
      : $status === 'upcoming'
        ? '#6366f1'
        : '#9ca3af'};
`

export const TitleContainer = styled.div`
  flex-direction: row;
  display: flex;
  gap: 5px;
  align-items: center;
  width: 100%;

  svg {
    font-size: 30px;
  }
`
export const PreviewTitle = styled.h3`
  margin: 8px 0 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
`

export const PreviewMeta = styled.p`
  margin: 2px 0;
  font-size: 13px;
  color: #6b7280;
`

export const PreviewHashtags = styled.p`
  margin: 4px 0 0;
  font-size: 13px;
  color: #111827;
`

const Preview = () => {
  const { formState } = useChallenge()
  const { onEditionMode } = useUser()

  const badgeLabel = translateStatus(formState.status)

  const formatRange = () => {
    if (!formState.startDate && !formState.endDate) return ''
    const fmt = (d: string) => (d ? d.split('-').join('.') : '')
    return `${fmt(formState.startDate)}  –  ${fmt(formState.endDate)}`
  }

  const icon = formState.category === 'Reels' ? <TbPhotoVideo /> : <FiCamera />

  return (
    <PlainCard
      key="challenge-preview"
      title={onEditionMode ? 'Vista previa' : ''}
    >
      <PreviewCard>
        {formState.image ? (
          <PreviewImage src={formState.image} alt={formState.altText} />
        ) : (
          <PreviewImage
            as="div"
            style={{
              background: 'linear-gradient(135deg,#111827,#334155)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: 14,
            }}
          >
            Portada del desafío
          </PreviewImage>
        )}

        <PreviewBadge $status={formState.status}>{badgeLabel}</PreviewBadge>
        <TitleContainer>
          <div>{icon}</div>
          <div>
            <PreviewTitle>
              {formState.title || 'Título del desafío'}
            </PreviewTitle>
            <PreviewMeta>{formatRange()}</PreviewMeta>
          </div>
        </TitleContainer>

        <PreviewMeta>{formState.description}</PreviewMeta>
        <PreviewHashtags>
          {formState.hashtags.map((tag) => `#${tag}`).join(' ')}
        </PreviewHashtags>
      </PreviewCard>
    </PlainCard>
  )
}

export default Preview
